module.exports = __webpack_public_path__ + "img/Flag_of_French_Guiana.ddcc9372.svg";